const tooltips = document.querySelectorAll(".custom-tooltip");

tooltips.forEach(tooltip => {
  tooltip.addEventListener("mouseover", tooltipActive);
  tooltip.addEventListener("mouseout", tooltipInactive);
});

function tooltipActive(e) {
    if (e.target.children[0]) {
      e.target.children[0].classList.add("custom-tooltip__content--active");
    } else {
      e.target.nextElementSibling.classList.add(
        "custom-tooltip__content--active"
      );
    }
  }

  function tooltipInactive(e) {
    if (e.target.children[0]) {
      e.target.children[0].classList.remove("custom-tooltip__content--active");
    } else {
      e.target.nextElementSibling.classList.remove(
        "custom-tooltip__content--active"
      );
    }
  }
